import React from "react";
import { WizTableForm } from '@/containers/common'
import moment from 'moment'
const offlineProgram = WizTableForm.Config.offlineProgram(this, {apiParams: {}});
const organization = { allowTreeSelect: true , ...WizTableForm.Config.organization(this)}
const position = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const user = WizTableForm.Config.user(this, { apiParams: { state: 1 } })

//配置项
const componentName = "offlineProgramReport";

function columns() {
  return [
    {
      title: "主题名称",
      name: "name",
      tableItem: {},
    },
    {
      title: "主题名称",
      name: "offlineProgramIds",
      searchItem: {
        ...offlineProgram,
        diy: WizTableForm,
        rules: [
          {
            required: true,
            message: '请选择课程名称'
          }
        ]
      },
    },
    {
      title: "主题编号",
      name: "code",
      tableItem: {},
    },
    {
      title: "主题分类名称",
      name: "programCategoryName",
      tableItem: {},
    },
    {
      title: "学员账号",
      name: "account",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "fullName",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "personIds",
      searchItem: {
        ...user,
        diy: WizTableForm,
      },
    },
    // {
    //   title: "学员身份证",
    //   name: "idCard",
    //   tableItem: {},
    // },
    {
      title: "账号状态",
      name: "accountState",
      tableItem: {},
      searchItem: {
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '禁用' },
        { code: 1, codeName: '激活' },
      ]
    },
    {
      title: "上级组织",
      name: "leadName",
      tableItem: {},
    },
    {
      title: "上级组织",
      name: "parentOrgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
        onChangeRowMap: (e) => {},
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategoryName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategoryIds",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: []
      },
      searchItem: {
        type: 'treeselect',
        treeCheckable: true
      }
    },
    {
      title: "省份",
      name: "province",
      dataIndex: "province",
      tableItem: {},
      searchItem: {
      },
    },
    {
      title: "岗位名称",
      name: "positionName",
      tableItem: {},
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        ...position,
        diy: WizTableForm
      },
    },
    {
      title: "任职状态",
      name: "jobState",
      tableItem: {},
      searchItem: {
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '离职' },
        { code: 1, codeName: '在职' },
      ]
    },
    {
      title: "班级名称",
      name: "className",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "班级时间",
      name: "classDate",
      searchItem: {
        type: 'date~',
        showTime: true,
      },
    },
    {
      title: "班级开始时间",
      name: "classStartDate",
      tableItem: {},
    },
    {
      title: "班级结束时间",
      name: "classEndDate",
      tableItem: {},
    },
    {
      title: "成绩",
      name: "score",
      tableItem: {},
    },
    {
      title: "状态",
      name: "pass",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        { code: 0, codeName: '未输入' },
        { code: 1, codeName: '通过' },
        { code: 2, codeName: '未通过' },
        { code: 3, codeName: '无成绩' },
      ]
    },
    {
      title: "成绩获得时间",
      name: "scoreDate",
      tableItem: {},
    },
    {
      title: "提交报名时间",
      name: "applyDate",
      tableItem: {},
    },
    {
      title: "报名状态",
      name: "leaveState",
      searchItem: {
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '已报名已通过' },
        { code: 1, codeName: '已通过已请假' },
      ]
    },
    {
      title: "报名状态",
      name: "applyStatus",
      tableItem: {},
    },
    {
      title: "培训天数",
      name: "studyDay",
      tableItem: {},
    },
    {
      title: "出勤情况",
      name: "attendanceState",
      dict: [
        { code: 1, codeName: "请假" },
        { code: 2, codeName: "全勤" },
        { code: 3, codeName: "缺勤" },
      ],
      tableItem: {},
    },
    {
      title: "评语",
      name: "comment",
      tableItem: {},
    },
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort:['export','simpleExport'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            },
            {
              key: 'simpleExport',
              custom: true,
              params: { icon: 'export', children: '简易导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "simpleExport",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign({}, v)
            if (value['classDate'] && value['classDate'].length === 2) {
              value['classStartDate'] = moment(value['classDate'][0]).format("YYYY-MM-DD HH:mm:00")
              value['classEndDate'] = moment(value['classDate'][1]).format("YYYY-MM-DD HH:mm:59")
            } else {
              value['classStartDate'] = undefined
              value['classEndDate'] = undefined
            }
            return value
          }
        },
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageList`,
    payload: {
      key: `${componentName}@getPageList`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  simpleExport: {
    path: `${componentName}/simpleExport`,
    payload: {
      key: `${componentName}@simpleExport`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `${componentName}@orgNodeCategoryTree`,
      apiParams: {}
    }
  }
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["orgNodeCategoryTree"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
